import { Injectable } from '@angular/core';
import { CommonService } from 'src/@services/common.service';
import { EndPoints } from 'src/@shared/enum';

@Injectable({
  providedIn: 'root',
})
export class InnerPagesApiService {
  constructor(private _cS: CommonService) {}
  /*users*/
  getUsers(requestBody) {
    return this._cS.API_POST(EndPoints.GetUsers, requestBody, false);
  }
  getRolesList() {
    return this._cS.API_GET(
      EndPoints.GetRoleDropdownList + `?roleType=All`,
      false
    );
  }
  /*Investments*/
  getInvestments(
    searchText: any,
    sortField: any,
    page: any,
    pageSize: any,
    sortOrder: any,
    filterByStatus: any,
    InvestmentType: any
  ) {
    return this._cS.API_GET(
      EndPoints.GetEstimates +
      `?searchText=${searchText}&sortField=${sortField}&page=${page}&pageSize=${pageSize}&sortOrder=${sortOrder}&filterByStatus=${filterByStatus}&InvestmentType=${InvestmentType}`,
      false
    );
  }

  getEstimateAndInvoices(requestBody: any) {
    return this._cS.API_POST(
      EndPoints.GetEstimateAndInvoices,
      requestBody,
      false
    );
  }
  getUnderReviewPayments(requestBody: any) {
    return this._cS.API_POST(
      EndPoints.GetUnderReviewPayments,
      requestBody,
      false
    );
  }
  getUnderReviewInvestments(requestBody: any) {
    return this._cS.API_POST(EndPoints.GetUnderReviews, requestBody, false);
  }
  getEstimateAndInvoicesFilters(requestBody: any) {
    return this._cS.API_POST(
      EndPoints.GetEstimateAndInvoicesFilters,
      requestBody,
      false
    );
  }
  getFutureInvestmentsFilters(requestBody: any) {
    return this._cS.API_POST(
      EndPoints.GetFutureInvestmentsFilters,
      requestBody,
      false
    );
  }
  getRefundInvestmentsFilters(requestBody: any) {
    return this._cS.API_POST(
      EndPoints.GetRefundInvestmentsFilters,
      requestBody,
      false
    );
  }
  getInternalTransfersFilters(requestBody: any) {
    return this._cS.API_POST(
      EndPoints.GetInternalTransfersFilters,
      requestBody,
      false
    );
  }

  getFutureInvestments(requestBody: any) {
    return this._cS.API_POST(EndPoints.GetFutures, requestBody, false);
  }

  getRefundInvestments(requestBody: any) {
    return this._cS.API_POST(
      EndPoints.GetRefundInvestments,
      requestBody,
      false
    );
  }
  getAllFilters() {
    return this._cS.API_GET(EndPoints.GetAllFilters, false);
  }

  getRefunds(requestBody: any) {
    return this._cS.API_POST(EndPoints.GetRefundsList, requestBody, false);
  }
  //delete unit
  deleteUser(userId: any) {
    const url = EndPoints.DeleteUser + `/${userId}`;
    return this._cS.API_DELETE(url);
  }

  //DeleteInvestment*/
  DeleteInvestment(formData: any) {
    let hd = this._cS.GetAuthorizationHeader();
    return this._cS.API_POST(EndPoints.DeleteInvestment, formData, false, {
      headers: hd,
    });
  }

  /*users*/
  getAgencys(
    searchText: any,
    sortField: any,
    page: any,
    pageSize: any,
    sortBy: any,
    filterByStatus: any
  ) {
    return this._cS.API_GET(
      EndPoints.getAllAgency +
      `?searchText=${searchText}&sortField=${sortField}&page=${page}&pageSize=${pageSize}&sortOrder=${sortBy}&filterByStatus=${filterByStatus}`,
      false
    );
  }
  getAccounts(requestBody) {
    return this._cS.API_POST(EndPoints.getAllAccounts, requestBody, false);
  }

  getAccountDropdownList(accountType: any) {
    return this._cS.API_GET(
      EndPoints.GetAccountDropdownList + `?accountAgencyType=${accountType}`,
      false
    );
  }

  getAccountTypesForFilter(accountType: number) {
    return this._cS.API_GET(
      EndPoints.GetAccountTypesForFilter + `?accountTypeEnum=${accountType}`,
      false
    );
  }
  GetAgencyDropdownList() {
    return this._cS.API_GET(EndPoints.GetAgencyDropdownList, false);
  }
  GetAgencyDropdown() {
    return this._cS.API_GET(EndPoints.GetAgencyDropdown, false);
  }
  getAssignmentsForFilter(agencyType: any = 1) {
    return this._cS.API_GET(
      EndPoints.GetAssignmentsForFilter + `?agencyType=${agencyType}`,
      false
    );
  }
  getSites(requestBody: any) {
    return this._cS.API_POST(EndPoints.getAllSites, requestBody, false);
  }

  getSuppliersAndRepsFilter() {
    return this._cS.API_GET(EndPoints.GetSupplierUserFilters, false);
  }

  //resync data
  resyncQBOData(requestBody: any) {
    return this._cS.API_POST(
      EndPoints.ResyncQBOTransactions,
      requestBody,
      false
    );
  }

  getOverviewData(formdata: any) {
    let hd = this._cS.GetAuthorizationHeader();
    return this._cS.API_POST(EndPoints.GetOverviewData, formdata, false, {
      headers: hd,
    });
  }
  getSiteOverviewData(formdata: any) {
    let hd = this._cS.GetAuthorizationHeader();
    return this._cS.API_POST(EndPoints.GetSiteOverviewData, formdata, false, {
      headers: hd,
    });
  }
  getFavoriteSiteOverviewData(formdata: any) {
    let hd = this._cS.GetAuthorizationHeader();
    return this._cS.API_POST(
      EndPoints.GetFavoriteSiteOverviewData,
      formdata,
      false,
      {
        headers: hd,
      }
    );
  }
  // MakeAfavoritgeSite
  favoriteSite(siteId: any) {
    return this._cS.API_POST(EndPoints.FavoriteSite + `?siteId=${siteId}`);
  }
  // MakeAUnfavoriteSite
  unFavoriteSite(siteId: any) {
    return this._cS.API_POST(EndPoints.UnFavoriteSite + `?siteId=${siteId}`);
  }

  getOverviewChartData(formdata: any) {
    let hd = this._cS.GetAuthorizationHeader();
    return this._cS.API_POST(EndPoints.GetOverviewChartData, formdata, false, {
      headers: hd,
    });
  }
  getCashFlow() {
    return this._cS.API_GET(EndPoints.GetCashFlow, false);
  }

  GetSiteDetail(formdata: any) {
    let hd = this._cS.GetAuthorizationHeader();
    return this._cS.API_POST(EndPoints.GetSiteDetailReport, formdata, false, {
      headers: hd,
    });
  }

  getHistoricalReports(formdata: any) {
    let hd = this._cS.GetAuthorizationHeader();
    return this._cS.API_POST(EndPoints.HistoricalReports, formdata, false, {
      headers: hd,
    });
  }

  getAccountByAgency(formdata: any) {
    const hd = this._cS.GetAuthorizationHeader();
    return this._cS.API_POST(EndPoints.getAccountByAgency, formdata, false, {
      headers: hd,
    });
  }

  getSiteByAccountList(formdata: any) {
    const hd = this._cS.GetAuthorizationHeader();
    return this._cS.API_POST(
      EndPoints.GetSiteByAccountDropdownList,
      formdata,
      false,
      { headers: hd }
    );
  }
  getSiteByAccount(formdata: any) {
    const hd = this._cS.GetAuthorizationHeader();
    return this._cS.API_POST(
      EndPoints.GetSiteByAccountDropdown,
      formdata,
      false,
      { headers: hd }
    );
  }
  //delete Agency
  deleteAgency(agencyId: any) {
    return this._cS.API_DELETE(EndPoints.DeleteAgency + `/${agencyId}`, false);
  }
  //delete Account; forceDelete removes user assignments when present (Super Admin / Accountant)
  deleteAccount(accountId: string, forceDelete: boolean = false) {
    const forceQuery = forceDelete ? '?forceDelete=true' : '';
    return this._cS.API_DELETE(
      EndPoints.DeleteAccount + `/${accountId}${forceQuery}`,
      false
    );
  }

  getAccountDependencies(Id: string) {
    return this._cS.API_GET(EndPoints.GetAccountDependencies + `/${Id}`, false);
  }

  getSiteDependencies(Id: string) {
    return this._cS.API_GET(EndPoints.GetSiteDependencies + `/${Id}`, false);
  }

  //delete site; forceDelete removes user assignments when present (Super Admin / Accountant)
  deleteSite(Id: string, forceDelete: boolean = false) {
    const forceQuery = forceDelete ? '?forceDelete=true' : '';
    return this._cS.API_DELETE(EndPoints.DeleteSite + `/${Id}${forceQuery}`);
  }

  /*Preferred Vendors*/
  getAllvendors(
    siteId: any,
    page: any,
    pageSize: any,
    sortBy: any,
    sortField: string
  ) {
    return this._cS.API_GET(
      EndPoints.GetAllVendors +
      `?siteId=${siteId}&startPosition=${page}&pageSize=${pageSize}&sortOrder=${sortBy}&sortField=${sortField}`,
      false
    );
  }

  getAllRoles(
    searchText: any,
    sortField: any,
    page: any,
    pageSize: any,
    sortBy: any,
    filterByStatus: any,
    roleType: any,
    filterByBrooklynAccess: any
  ) {
    return this._cS.API_GET(
      EndPoints.GetAllRoles +
      `?searchText=${searchText}&sortField=${sortField}&page=${page}&pageSize=${pageSize}&sortBy=${sortBy}&filterByStatus=${filterByStatus}&roleType=${roleType}&filterByBrooklynAccess=${filterByBrooklynAccess}`,
      false
    );
  }

  getInternalUserDropdown() {
    return this._cS.API_GET(EndPoints.GetInternalUsersDropdown);
  }

  //delete role
  deleteRole(roleId: any) {
    return this._cS.API_POST(EndPoints.DeleteRole + `/${roleId}`);
  }

  getAllSupplier(requestBody: any) {
    return this._cS.API_POST(EndPoints.getAllSupplier, requestBody, false);
  }

  getUnlinkedSuppliers(requestBody: any) {
    return this._cS.API_POST(EndPoints.getUnlinkedSuppliers, requestBody, false);
  }

  paybevAutoLogin(formData: any) {
    const hd = this._cS.GetAuthorizationHeader();
    return this._cS.API_POST(EndPoints.PayBevAutoLogin, formData, false, {
      headers: hd,
    });
  }

  getAllReps(requestBody: any) {
    return this._cS.API_POST(EndPoints.getAllReps, requestBody, false);
  }
  updateInvoiceStatus(formData: any) {
    let hd = this._cS.GetAuthorizationHeader();
    return this._cS.API_POST(EndPoints.UpdateInvoiceStatus, formData, false, {
      headers: hd,
    });
  }
  updateSupplier(formData: any) {
    let hd = this._cS.GetAuthorizationHeader();
    return this._cS.API_POST(EndPoints.UpdateRepsProfile, formData, false, {
      headers: hd,
    });
  }
  updateSupplierDetails(requestBody: any) {
    return this._cS.API_POST(
      EndPoints.UpdateSupplierDetails,
      requestBody,
      false
    );
  }
  getQBOClass() {
    return this._cS.API_POST(EndPoints.QBOClass, null, false, {
      responseType: 'text',
    });
  }
  logOut() {
    return this._cS.API_GET(EndPoints.LogOut, false);
  }
  /*Preferred Vendors*/
  getAllNonAlcData(
    siteId: any,
    page: any,
    pageSize: any,
    sortBy: any,
    sortField: any,
    transactionType: any
  ) {
    return this._cS.API_GET(
      EndPoints.GetNonAlcTransaction +
      `?siteId=${siteId}&page=${page}&pageSize=${pageSize}&sortby=${sortBy}&sortField=${sortField}&transactionType=${transactionType}`,
      false
    );
  }

  /**
   * SetCookie Method (Locally Value set)
   * @param cname - CookieName Like 'Lst_Projects'
   * @param cvalue - CookieValue Like 'abc'
   * @param exdays - CookieExpireDays Like 360
   */
  setCookie(cname: any, cvalue: any, exdays: any) {
    var d = new Date();
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
    var expires = 'expires=' + d.toUTCString();
    document.cookie =
      cname +
      '=' +
      cvalue +
      ';' +
      expires +
      ';domain=' +
      location.hostname.split('.').reverse().splice(0, 2).reverse().join('.') +
      ';path=/';
  }

  /**
   * GetCookie Method (Value get)
   * @param cname - CookieName Like Lst_Projects
   */
  getCookie(cname: any) {
    var name = cname + '=';
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return '';
  }

  /*GetAllVendorsRecords*/
  GetAllVendorsRecords(requestBody: any) {
    return this._cS.API_POST(
      EndPoints.GetAllVendorsRecords,
      requestBody,
      false
    );
  }
  UpdateVendorStatus(requestBody: any) {
    return this._cS.API_POST(EndPoints.UpdateVendorStatus, requestBody, false);
  }

  //update supplier status
  UpdateSupplierStatus(requestBody: any) {
    return this._cS.API_POST(
      EndPoints.UpdateSupplierStatus,
      requestBody,
      false
    );
  }
  UpdateSupplierNonAlcStatus(requestBody: any) {
    let hd = this._cS.GetAuthorizationHeader();
    return this._cS.API_POST(
      EndPoints.UpdateSupplierNonAlcStatus,
      requestBody,
      false,
      {
        headers: hd,
      }
    );
  }
  UpdateTransactionIsSeen(requestBody: any) {
    return this._cS.API_POST(
      EndPoints.UpdateTransactionIsSeen,
      requestBody,
      false
    );
  }
  UpdateInvestmentDescription(requestBody: any) {
    let hd = this._cS.GetAuthorizationHeader();
    return this._cS.API_POST(
      EndPoints.UpdateInvestmentDescription,
      requestBody,
      false,
      {
        headers: hd,
      }
    );
  }
  UpdateBadgeTransaction(requestBody: any) {
    return this._cS.API_POST(
      EndPoints.UpdateBadgeTransaction,
      requestBody,
      false
    );
  }

  reInviteUser(requestBody: any) {
    return this._cS.API_POST(EndPoints.ReInviteUser, requestBody, false);
  }

  GetInvestmentDescription() {
    return this._cS.API_GET(EndPoints.GetInvestmentDescription, false);
  }

  getPendingTransactionsCounts(
    TransactionsType: any,
    isUnderReviewTab: boolean
  ) {
    return this._cS.API_GET(
      EndPoints.GetTransactionCount +
      `?TransactionsType=${TransactionsType}&IsUnderReviewTab=${isUnderReviewTab}`,
      false
    );
  }

  getAllBills(
    searchText: any,
    sortField: any,
    page: any,
    pageSize: any,
    sortBy: any,
    filterByStatus: any,
    expenseStatus?: any
  ) {
    if (expenseStatus) {
      return this._cS.API_GET(
        EndPoints.getAllBills +
        `?searchText=${searchText}&sortField=${sortField}&page=${page}&pageSize=${pageSize}&sortOrder=${sortBy}&filterByStatus=${filterByStatus}&ExpenseStatus=${expenseStatus}`,
        false
      );
    } else {
      return this._cS.API_GET(
        EndPoints.getAllBills +
        `?searchText=${searchText}&sortField=${sortField}&page=${page}&pageSize=${pageSize}&sortOrder=${sortBy}&filterByStatus=${filterByStatus}`,
        false
      );
    }
  }
  getBills(requestBody) {
    return this._cS.API_POST(EndPoints.GetBills, requestBody, false);
  }
  getBillsFilters(requestBody) {
    return this._cS.API_POST(EndPoints.GetBillsFilters, requestBody, false);
  }
  getAllExpenses(requestBody) {
    return this._cS.API_POST(EndPoints.GetExpensesV2, requestBody, false);
  }
  getExpensesFilters(requestBody) {
    return this._cS.API_POST(EndPoints.GetExpensesFilters, requestBody, false);
  }
  getAllEmails(requestBody) {
    return this._cS.API_POST(EndPoints.GetAllUserEmails, requestBody, false);
  }
  exportUsers(requestBody: any) {
    let hd = this._cS.GetAuthorizationHeader();
    return this._cS.API_POST(EndPoints.ExportUsers, requestBody, false, {
      responseType: 'blob',
      headers: hd,
    });
  }
  exportToExcelBills(requestBody) {
    let hd = this._cS.GetAuthorizationHeader();
    return this._cS.API_POST(EndPoints.ExportBills, requestBody, false, {
      responseType: 'blob',
      headers: hd,
    });
  }
  exportToExcelExpenses(requestBody) {
    let hd = this._cS.GetAuthorizationHeader();
    return this._cS.API_POST(EndPoints.ExportExpense, requestBody, false, {
      responseType: 'blob',
      headers: hd,
    });
  }
  exportToExcelInternalTransfers(requestBody) {
    let hd = this._cS.GetAuthorizationHeader();
    return this._cS.API_POST(
      EndPoints.ExportInternalTransfers,
      requestBody,
      false,
      {
        responseType: 'blob',
        headers: hd,
      }
    );
  }
  exportToExcelUnderReviewInvestments(requestBody) {
    let hd = this._cS.GetAuthorizationHeader();
    return this._cS.API_POST(EndPoints.ExportUnderReviews, requestBody, false, {
      responseType: 'blob',
      headers: hd,
    });
  }
  exportToExcelUnderReviewPayments(requestBody) {
    let hd = this._cS.GetAuthorizationHeader();
    return this._cS.API_POST(
      EndPoints.ExportUnderReviewPayments,
      requestBody,
      false,
      {
        responseType: 'blob',
        headers: hd,
      }
    );
  }

  exportToExcelAccounts(requestBody: any) {
    let hd = this._cS.GetAuthorizationHeader();
    return this._cS.API_POST(EndPoints.ExportAccounts, requestBody, false, {
      responseType: 'blob',
      headers: hd,
    });
  }

  exportToExcelSites(requestBody: any) {
    let hd = this._cS.GetAuthorizationHeader();
    return this._cS.API_POST(EndPoints.ExportSites, requestBody, false, {
      responseType: 'blob',
      headers: hd,
    });
  }

  deletePayment(paymentId: any) {
    return this._cS.API_DELETE(
      EndPoints.DeletePayment + `?paymentId=${paymentId}`
    );
  }

  //Get All Expense
  GetExpenses(
    searchText: any,
    sortField: any,
    page: any,
    pageSize: any,
    sortBy: any
  ) {
    return this._cS.API_GET(
      EndPoints.GetExpenses +
      `?searchText=${searchText}&sortField=${sortField}&page=${page}&pageSize=${pageSize}&sortOrder=${sortBy}`,
      false
    );
  }

  deleteExpense(expenseId: any) {
    return this._cS.API_DELETE(
      EndPoints.DeleteExpense + `?expenseID=${expenseId}`
    );
  }

  //Get All credits
  GetCredits(
    searchText: any,
    sortField: any,
    page: any,
    pageSize: any,
    sortBy: any,
    typeFilter: any
  ) {
    return this._cS.API_GET(
      EndPoints.GetCredits +
      `?searchText=${searchText}&sortField=${sortField}&page=${page}&pageSize=${pageSize}&sortOrder=${sortBy}&typeFilter=${typeFilter}`,
      false
    );
  }
  GetCreditsV2(requestBody: any) {
    return this._cS.API_POST(EndPoints.GetCreditsV2, requestBody, false);
  }
  GetCreditsFilers(requestBody: any) {
    return this._cS.API_POST(EndPoints.GetCreditsFilters, requestBody, false);
  }
  ExportCredits(requestBody: any) {
    let hd = this._cS.GetAuthorizationHeader();

    return this._cS.API_POST(EndPoints.ExportCredits, requestBody, false, {
      responseType: 'blob',
      headers: hd,
    });
  }

  //Get All Deposits
  GetDeposits(
    searchText: any,
    sortField: any,
    page: any,
    pageSize: any,
    sortBy: any
  ) {
    return this._cS.API_GET(
      EndPoints.GetDeposits +
      `?searchText=${searchText}&sortField=${sortField}&page=${page}&pageSize=${pageSize}&sortOrder=${sortBy}`,
      false
    );
  }

  GetDepositsV2(requestBody: any) {
    return this._cS.API_POST(EndPoints.GetDepositsV2, requestBody, false);
  }
  GetDepositsFilters(requestBody: any) {
    return this._cS.API_POST(EndPoints.GetDepositsFilters, requestBody, false);
  }
  ExportDeposits(requestBody: any) {
    let hd = this._cS.GetAuthorizationHeader();

    return this._cS.API_POST(EndPoints.ExportDeposits, requestBody, false, {
      responseType: 'blob',
      headers: hd,
    });
  }

  //Get All accounts by Agency Type
  GetAllAccountsForSites(agencyType: number) {
    return this._cS.API_GET(
      EndPoints.GetAccountDropdownListByAgencyType + '?agencyType=' + agencyType
    );
  }

  //export excel reports
  exportToExcelReports(formdata: any) {
    let hd = this._cS.GetAuthorizationHeader();
    return this._cS.API_POST(EndPoints.ExportToExcelReports, formdata, false, {
      headers: hd,
    });
  }
  exportToExcelFutures(requestBody: any) {
    let hd = this._cS.GetAuthorizationHeader();
    return this._cS.API_POST(
      EndPoints.ExportToExcelFutures,
      requestBody,
      false,
      {
        responseType: 'blob',
        headers: hd,
      }
    );
  }
  exportToExcelRefunds(requestBody: any) {
    let hd = this._cS.GetAuthorizationHeader();
    return this._cS.API_POST(
      EndPoints.ExportToExcelRefunds,
      requestBody,
      false,
      {
        responseType: 'blob',
        headers: hd,
      }
    );
  }
  exportToExcelEstimatesInvoices(requestBody: any) {
    let hd = this._cS.GetAuthorizationHeader();
    return this._cS.API_POST(
      EndPoints.ExportToExcelEstimatesInvoices,
      requestBody,
      false,
      {
        responseType: 'blob',
        headers: hd,
      }
    );
  }


  exportToExcelSuppliers(requestBody: any) {
    let hd = this._cS.GetAuthorizationHeader();
    return this._cS.API_POST(
      EndPoints.ExportSuppliers,
      requestBody,
      false,
      {
        responseType: 'blob',
        headers: hd,
      }
    );
  }

  exportToExcelReps(requestBody: any) {
    let hd = this._cS.GetAuthorizationHeader();
    return this._cS.API_POST(
      EndPoints.ExportReps,
      requestBody,
      false,
      {
        responseType: 'blob',
        headers: hd,
      }
    );
  }

  //Get All Expense
  GetInternalTransfers(
    searchText: any,
    sortField: any,
    page: any,
    pageSize: any,
    sortBy: any
  ) {
    return this._cS.API_GET(
      EndPoints.GetInternalTransfers +
      `?searchText=${searchText}&sortField=${sortField}&page=${page}&pageSize=${pageSize}&sortOrder=${sortBy}`,
      false
    );
  }
  GetInternalTransfersV2(requestBody: any) {
    return this._cS.API_POST(
      EndPoints.GetInternalTransfersV2,
      requestBody,
      false
    );
  }
  //maintenance
  getAllMaintenance(
    searchText: any,
    sortField: any,
    page: any,
    pageSize: any,
    sortBy: any
  ) {
    return this._cS.API_GET(
      EndPoints.GetMaintenance +
      `?searchText=${searchText}&startPosition=${page}&pageSize=${pageSize}&sortOrder=${sortBy}&sortField=${sortField}`,
      false
    );
  }

  addOrUpdateMaintenance(requestBody: any) {
    return this._cS.API_POST(
      EndPoints.AddOrUpdateMaintenance,
      requestBody,
      false
    );
  }

  //announcement
  getAllAnnouncements(
    searchText: any,
    sortField: any,
    page: any,
    pageSize: any,
    sortBy: any
  ) {
    return this._cS.API_GET(
      EndPoints.GetAllAnnouncements +
      `?searchText=${searchText}&startPosition=${page}&pageSize=${pageSize}&sortOrder=${sortBy}&sortField=${sortField}`,
      false
    );
  }

  getAllRetailPrograms(requestBody: any) {
    return this._cS.API_POST(
      EndPoints.GetAllRetailPrograms,
      requestBody,
      false
    );
  }

  InactiveOrDeleteAnnouncement(requestBody: any) {
    return this._cS.API_POST(
      EndPoints.InactiveOrDeleteAnnouncement,
      requestBody,
      false
    );
  }

  DeleteRetailProgram(retailProgramId: any) {
    return this._cS.API_DELETE(
      EndPoints.DeleteRetailProgram + `/${retailProgramId}`,
      false
    );
  }

  //badges
  GetAllBadges(
    searchText: any,
    sortField: any,
    page: any,
    pageSize: any,
    sortBy: any,
    transactionType: number
  ) {
    return this._cS.API_GET(
      EndPoints.GetAllBadges +
      `?searchText=${searchText}&startPosition=${page}&pageSize=${pageSize}&sortOrder=${sortBy}&sortField=${sortField}&transactionType=${transactionType}`,
      false
    );
  }
  getAllInvestmentBadges() {
    return this._cS.API_GET(EndPoints.GetAllInvestmentBadges, false);
  }
  getAllPaymentBadges() {
    return this._cS.API_GET(EndPoints.GetAllPaymentBadges, false);
  }
  UpdateOrderNumber(requestBody: any) {
    const hd = this._cS.GetAuthorizationHeader();
    return this._cS.API_POST(EndPoints.UpdateOrderNo, requestBody, false, {
      headers: hd,
    });
  }
  UpdateResourceOrderNumber(requestBody: any) {
    const hd = this._cS.GetAuthorizationHeader();
    return this._cS.API_POST(
      EndPoints.UpdateResourceOrderNo,
      requestBody,
      false,
      {
        headers: hd,
      }
    );
  }
  //under reviews
  GetAllUnderReviews(
    searchText: any,
    sortField: any,
    page: any,
    pageSize: any,
    sortBy: any,
    transactionType: number
  ) {
    return this._cS.API_GET(
      EndPoints.GetAllUnderReview +
      `?searchText=${searchText}&startPosition=${page}&pageSize=${pageSize}&sortBy=${sortBy}&sortField=${sortField}&transactionType=${transactionType}`,
      false
    );
  }
  UpdateUROrderNumber(requestBody: any) {
    const hd = this._cS.GetAuthorizationHeader();
    return this._cS.API_POST(
      EndPoints.UpdateUnderReviewOrderNo,
      requestBody,
      false,
      {
        headers: hd,
      }
    );
  }

  //resources
  GetAllResources(
    searchText: any,
    sortField: any,
    page: any,
    pageSize: any,
    sortBy: any,
    resourceType: number
  ) {
    return this._cS.API_GET(
      EndPoints.GetResourceRecords +
      `?searchText=${searchText}&startPosition=${page}&pageSize=${pageSize}&sortOrder=${sortBy}&sortField=${sortField}&resourceType=${resourceType}`,
      false
    );
  }

  DeleteResource(resourceId: any) {
    return this._cS.API_DELETE(
      EndPoints.DeleteResource + `/${resourceId}`,
      false
    );
  }

  //account types
  GetAllAccountTypes(
    searchText: any,
    sortField: any,
    page: any,
    pageSize: any,
    sortBy: any,
    typeCategory: number,
    filterByStatus: any
  ) {
    return this._cS.API_GET(
      EndPoints.GetAllAccountTypes +
      `?searchText=${searchText}&startPosition=${page}&pageSize=${pageSize}&sortOrder=${sortBy}&sortField=${sortField}&typeCategory=${typeCategory}&filterByStatus=${filterByStatus}`,
      false
    );
  }
  GetAmDirectorUsers(agencyType: number) {
    return this._cS.API_GET(
      EndPoints.GetAmDirectorUsers + `?agencyType=${agencyType}`,
      false
    );
  }
  //badges
  GetAllBadgesDropdown() {
    return this._cS.API_GET(EndPoints.GetAllBadgesRecords, false);
  }
  //transaction
  GetTransactionCount() {
    return this._cS.API_GET(EndPoints.GetTransactionCount, false);
  }
  DeleteBadge(requestBody: any) {
    return this._cS.API_POST(EndPoints.DeleteBadge, requestBody, false);
  }
  DeleteUnderReview(underReviewId: any) {
    return this._cS.API_DELETE(
      EndPoints.DeleteUnderReview + `/${underReviewId}`,
      false
    );
  }
  DeleteAccountType(requestBody: any) {
    return this._cS.API_POST(
      EndPoints.DeleteAccountType + `/${requestBody}`,
      false
    );
  }

  getProjectionGoalGrid(requestBody: {
    calendarYear: number;
    agencyIds: string;
    searchText: string;
    sites?: string;
    accounts?: string;
    classes?: string;
    directors?: string;
    accountManagers?: string;
    users?: string;
    sortField: string;
    sortOrder: string;
    page: number;
    pageSize: number;
  }) {
    const hd = this._cS.GetAuthorizationHeader();
    return this._cS.API_POST(EndPoints.GetProjectionGoalGrid, requestBody, false, {
      headers: hd,
    });
  }

  getProjectionGridFilters(requestBody: {
    calendarYear: number;
    agencyIds: string;
    searchText: string;
    sites?: string;
    accounts?: string;
    classes?: string;
    directors?: string;
    accountManagers?: string;
    users?: string;
  }) {
    const hd = this._cS.GetAuthorizationHeader();
    return this._cS.API_POST(EndPoints.GetProjectionGridFilters, requestBody, false, {
      headers: hd,
    });
  }

  updateProjectionGoal(requestBody: {
    siteId: string;
    calendarYear: number;
    goalAmount: number;
  }) {
    const hd = this._cS.GetAuthorizationHeader();
    return this._cS.API_PUT(EndPoints.UpdateProjectionGoal, requestBody, false, {
      headers: hd,
    });
  }

  exportProjectionGoalGrid(requestBody: {
    calendarYear: number;
    agencyIds: string;
    searchText: string;
    sites?: string;
    accounts?: string;
    classes?: string;
    directors?: string;
    accountManagers?: string;
    users?: string;
    sortField: string;
    sortOrder: string;
    page: number;
    pageSize: number;
  }) {
    const hd = this._cS.GetAuthorizationHeader();
    return this._cS.API_POST(EndPoints.ExportProjectionGoalGrid, requestBody, false, {
      responseType: 'blob',
      headers: hd,
    });
  }

  getProjectionForecastGrid(requestBody: {
    calendarYear: number;
    agencyIds: string;
    searchText: string;
    onlyGoals: boolean;
    sites?: string;
    accounts?: string;
    classes?: string;
    directors?: string;
    accountManagers?: string;
    users?: string;
    sortField: string;
    sortOrder: string;
    page: number;
    pageSize: number;
  }) {
    const hd = this._cS.GetAuthorizationHeader();
    return this._cS.API_POST(EndPoints.GetProjectionForecastGrid, requestBody, false, {
      headers: hd,
    });
  }

  updateProjectionForecast(requestBody: {
    siteId: string;
    calendarYear: number;
    forecastAmount: number;
    startMonth: number;
  }) {
    const hd = this._cS.GetAuthorizationHeader();
    return this._cS.API_PUT(EndPoints.UpdateProjectionForecast, requestBody, false, {
      headers: hd,
    });
  }

  checkProjectionCyPyNeedsSync(requestBody: { calendarYear: number; siteIds?: string[] }) {
    const hd = this._cS.GetAuthorizationHeader();
    return this._cS.API_POST(EndPoints.CheckProjectionCyPyNeedsSync, requestBody, false, {
      headers: hd,
    });
  }

  syncProjectionCyPy(requestBody: { calendarYear: number; siteIds?: string[] }) {
    const hd = this._cS.GetAuthorizationHeader();
    return this._cS.API_POST(EndPoints.SyncProjectionCyPy, requestBody, false, {
      headers: hd,
    });
  }

  getProjectionSyncCyPyStatus(jobId: string) {
    const hd = this._cS.GetAuthorizationHeader();
    return this._cS.API_GET(`${EndPoints.GetProjectionSyncCyPyStatus}/${jobId}`, false, {
      headers: hd,
    });
  }

  exportProjectionForecastGrid(requestBody: {
    calendarYear: number;
    agencyIds: string;
    searchText: string;
    onlyGoals: boolean;
    sites?: string;
    accounts?: string;
    classes?: string;
    directors?: string;
    accountManagers?: string;
    users?: string;
    sortField: string;
    sortOrder: string;
    page: number;
    pageSize: number;
  }) {
    const hd = this._cS.GetAuthorizationHeader();
    return this._cS.API_POST(EndPoints.ExportProjectionForecastGrid, requestBody, false, {
      responseType: 'blob',
      headers: hd,
    });
  }

  exportInvestmentProjectionsReport(requestBody: { calendarYear: number; onlyGoals: boolean }) {
    const hd = this._cS.GetAuthorizationHeader();
    return this._cS.API_POST(EndPoints.InvestmentProjectionsExport, requestBody, false, {
      responseType: 'blob',
      headers: hd,
    });
  }

}
